module.exports = __webpack_public_path__ + "img/arrow.fd099d4f.gif";